module.exports = __webpack_public_path__ + "static/media/bob.6ad8f026.mp3";